import { FormPanel } from "../../../../modules/content/components/FormPanel/FormPanel";
import { AbyssCommonContent } from "../../../../modules/content/components/AbyssCommonContent/AbyssCommonContent";
import { AbyssSection } from "../../../../modules/content/components/AbyssSection/AbyssSection";
import type { IFormBlockProps } from "./FormBlock.props";

export const FormBlock = ({
  alignment,
  anchorId,
  buttons,
  description,
  errorMessage,
  eyebrow,
  fields,
  heading,
  parentClass,
  spacing,
  submitLabel,
  successMessage,
}: IFormBlockProps) => {
  if (!fields?.length) return null;
  return (
    <AbyssSection className={parentClass} id={anchorId} spacing={spacing}>
      <div className="grid gap-10 lg:grid-cols-[minmax(15rem,0.7fr)_minmax(0,1.3fr)] lg:items-start lg:gap-20">
        <AbyssCommonContent
          alignment={alignment}
          buttons={buttons}
          className="lg:pt-2"
          description={description}
          eyebrow={eyebrow}
          heading={heading}
        />
        <div className="w-full max-w-[44rem]">
          <FormPanel
            errorMessage={errorMessage}
            fields={fields}
            submitLabel={submitLabel}
            successMessage={successMessage}
          />
        </div>
      </div>
    </AbyssSection>
  );
};

FormBlock.displayName = "Block::FormBlock";
